<template>
<div class="flex flex-col h-full w-full justify-center">
  <div class="flex mx-auto max-w-4xl container border bg-white
        flex-col-reverse tablet:flex-row shadow-modal border-1 border-grey-lighter">
    <div class="flex flex-col justify-evenly tablet:w-1/2 p-5 tablet:p-10 tablet:border-r">
        <h1 class="my-5 tablet:my-0 text-center tablet:text-left">mibuilding access</h1>
        <input type="text"
        placeholder="Your work email"
        class="p-3 mt-3 tablet:mt-2 border rounded"
        />
        <input type="password"
        placeholder="Your password"
        class="p-3 mt-3 tablet:mt-2 border rounded"
        />
        <div class="flex flex-col my-5">
            <a href="#" class="button-primary block">log in</a>
            <a class="text-center tablet:text-left block" href="#">Forgot Password?</a>
        </div>
        <div class="text-center tablet:text-left mb-0">
        <span class="">
            Don't have nomado account?
            <router-link :to="{ name: 'signup' }">Sign Up</router-link>
        </span>
        </div>
    </div>
    <div class="flex flex-col justify-evenly tablet:w-1/2 p-5 tablet:p-10">
        <div>
            <img src="@/assets/nomado-trunk.svg" class="hidden tablet:block" />
        </div>
        <div class="mt-10">
            <span class="text-xs bg-green text-white-light px-2 py-1 rounded">
            new
            </span>
        </div>
        <div>
            <h2>entrée - smart visitor check-in!</h2>
            <p class="hidden text-sm text-justify tablet:block text-grey-light font-light">
                Help you organise and run your frondesk smoothly and focus on what it
                supposed to do - customer care. Automated and secure check-in specially
                designed for you!
            </p>
        </div>
    </div>
  </div>
</div>
</template>


<script>
export default {
    name: 'login-form',
    props: {
        msg: String
    }
};
</script>
